<template>
  <div class="donator-page">
    <section class="section-donator-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container d-flex">
        <div class="serach-box">
          <base-input
            alternative
            :placeholder="$t('Search_Donator')"
            addon-right-icon="fa fa-search"
            v-model="search"
          ></base-input>
        </div>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="donator-details-card">
            <div class="card-details">
              <b-table
                sticky-header="560px"
                head-variant="light"
                responsive="sm"
                striped
                hover
                :items="items"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :current-page="currentPage"
                :no-local-sorting="true"
                @sort-changed="sortingChanged"
                :fields="fields"
              >
                <template
                  v-slot:cell(campaign_name)="data"
                >{{ data.item && data.item.campaign_name ? data.item.campaign_name : data.item.organization_name}}</template>

                <template
                  v-slot:cell(payee_name)="data"
                >{{ data.item && data.item.payee_name ? data.item.payee_name : "NA"}}</template>

                <template
                  v-slot:cell(created_at)="data"
                >{{ data.item && data.item.created_at ? formatDate(data.item.created_at) : "NA"}}</template>
              </b-table>

              <b-pagination
                v-model="currentPage"
                :total-rows="paginate.total_items"
                :per-page="perPage"
                @change="myProvider"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>
<script>
import qs from "qs";
import axios from "axios";
import moment from "moment";
var clearTimeoutData;
export default {
  computed: {
    fields() {
      return [
        { 
           key: "transaction_reference",
            label: this.$t("Reference_Id"),
             sortable: true 
        },
        { 
          key: "amount",
           label: this.$t("Donation_Amount"),
            sortable: true 
        },
        { 
          key: "created_at",
           label: this.$t("Donation_Date"),
            sortable: true 
        },
        {
          key: "payee_name",
          label: this.$t("User_Name"),
          sortable: true,
          class: "max-200"
        },
        {
          key: "campaign_name",
          label: this.$t("Org_Proj"),
          sortable: true,
          class: "max-300"
        }
      ];
    }
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      sortBy: "created_at",
      sortDesc: true,
      isApiLoading: false,

      // fields: [
      //   { key: "transaction_reference", label: "Reference Id", sortable: true },
      //   { key: "amount", label: "Donation Amount", sortable: true },
      //   { key: "created_at", label: "Donation Date", sortable: true },
      //   {
      //     key: "payee_name",
      //     label: "User Name",
      //     sortable: true,
      //     class: "max-200"
      //   },
      //   {
      //     key: "campaign_name",
      //     label: "Organzation/Project",
      //     sortable: true,
      //     class: "max-300"
      //   }
      // ],
      items: [],
      search: "",
      paginate: {}
    };
  },
  methods: {
    myProvider(pageNumber) {
      this.getTransactionList(pageNumber);
      console.log("ctx obj", pageNumber);
    },
    sortingChanged(ctx) {
      console.log("ctx sort chnaged", ctx);
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getTransactionList();
    },

    getRequest(pageNumber) {
      var _filter = [];
      if (this.search) {
        _filter.push({
          type: "or",
          items: [
            {
              field: "campaign_name",
              value: "%" + this.search + "%",
              op: "ilike"
            },
            {
              field: "transaction_reference",
              value: "%" + this.search + "%",
              op: "ilike"
            },
            {
              field: "amount",
              value: "%" + this.search + "%",
              op: "ilike"
            },

            {
              field: "payee_name",
              value: "%" + this.search + "%",
              op: "ilike"
            }
          ]
        });
      }

      _filter.push({
        field: "type",
        value: "CREDIT"
      });
      _filter.push({
        field: "status",
        value: "SUCCESS"
      });

      var _response = {
        filters: _filter,
        // pagination : {
        //   page : this.pagination.page,
        //   page_size : this.pagination.rowsPerPage
        // //  page:1,
        // //  page_size:25
        // },
        pagination: {
          page: pageNumber,
          page_size: this.perPage
        },
        sorts: {}
      };
      if (this.sortBy) {
        _response.sorts[this.sortBy] = this.sortDesc == false ? "asc" : "desc";
      }
      return _response;
    },
    if(isApiLoading) {
      return;
    },
    getTransactionList(pageNumber) {
      this.isApiLoading = true;
      var _request = this.getRequest(pageNumber);
      var queryString = qs.stringify(_request);
      var urlWithService = process.env.VUE_APP_API_URL + `/transactions?`;
      urlWithService = urlWithService + queryString;

      const token = localStorage.getItem("token");

      axios({
        method: "get",
        url: urlWithService,
        headers: { Authorization: ` ${token}` }
      })
        .then(Response => {
          if (Response) {
            this.items = Response.data.list || [];
            this.paginate = Response.data.pagination || {};
          }
        })
        .catch(error => console.log("error in Donator list function", error));
      this.isApiLoading = false;
    },
    formatDate(date) {
      return moment.utc(date).format("YYYY/MM/DD");
    }
  },

  mounted() {
    this.getTransactionList();
  },
  watch: {
    search(val) {
      var me = this;
      if (clearTimeoutData) clearTimeout(clearTimeoutData);

      clearTimeoutData = setTimeout(() => {
        me.getTransactionList();
      }, 500);
    }

    //    sortBy: {
    //   handler() {
    //     this.getTransactionList();
    //   },
    //   deep: true
    // },

    // sortDesc(){
    //   // this.sortDesc = this.sortDesc == true ? 'asc' : 'desc';

    //   console.log("sort desc watch",this.sortDesc);
    // },
    // sortDesc:{
    //      handler() {
    //   this.getTransactionList();
    //   console.log("sort desc watch",this.sortDesc);
    //   console.log("sot by wacth",this.sortBy);
    // },
    // deep: true
    // }
  }
};
</script>
<style>
</style>
